import { Mail01 } from "@untitledui/icons/Mail01";
import { ArrowNarrowLeft } from "@untitledui/icons/ArrowNarrowLeft";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModals } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";
import TextButton from "../../components/Buttons/textButton";
import { forgotPassword_req } from "../../api/profiles.api";
import { useState } from "react";

const CheckEmailModal = () => {
  const dispatch = useDispatch();
  const modalEmail = useSelector((state) => state.modal.modalData);
  const [resendEmail, setResendEmail] = useState(false);
  const backToLogin = () => {
    dispatch(closeModal({}));

    dispatch(
      openModals({
        modalIds: [ModalsEnum.SIGN_IN_MODAL],
      })
    );
  };
  const resendBtn = async () => {
    const email = modalEmail?.email[0];
    await forgotPassword_req(email);
    setResendEmail(true);
  };

  return (
    <>
      <div className="modal-header text-center">
        <div className="icon purple">
          <Mail01 />
        </div>
        <h4 className="mb-8">Please check your email.</h4>
        <p className="text-color-grey">
          We've sent a password reset link to <span>{modalEmail?.email}</span>
        </p>
      </div>
      <div className="modal-body text-center">
        {!resendEmail && (
          <p className="have-account-question medium-text text-color-grey-700 mb-32">
            Didn’t receive the email?
            <TextButton
              text={"Click to resend"}
              className={"ml-8"}
              onClick={resendBtn}
            />
          </p>
        )}

        <button
          className="back-login-button flex flex-align-center flex-justify-center text-color-grey"
          onClick={backToLogin}
        >
          <ArrowNarrowLeft
            color={"#475467"}
            className={"mr-8"}
          />
          Back to Log In
        </button>
      </div>
    </>
  );
};

export default CheckEmailModal;
